import constant from "../constant";

const DIGITAL_PROFILE_PATH = "/account/profile";

const digitalBaseUrl = () =>
  constant.DIGITAL_BASE_URL.replace(/\/$/, "");

const readSsoToken = () => {
  if (typeof window === "undefined") return "";
  const value = window.localStorage.getItem("ssoToken");
  if (!value || value === "undefined" || value === "null") return "";
  return value.trim();
};

export function getDigitalProfileUrl() {
  const url = new URL(`${digitalBaseUrl()}${DIGITAL_PROFILE_PATH}`);
  const ssoToken = readSsoToken();
  if (ssoToken) {
    url.searchParams.set("ssoToken", ssoToken);
  }
  url.searchParams.set("source", "si");
  return url.toString();
}

export function redirectToDigitalProfile({ newTab = false } = {}) {
  const target = getDigitalProfileUrl();
  if (newTab) {
    window.open(target, "_blank", "noopener,noreferrer");
    return;
  }
  window.location.assign(target);
}
